import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

// Auto-reload on stale dynamic chunk errors (after a new deploy the old
// hashed chunks no longer exist on the CDN). We reload at most once per
// session to avoid infinite loops.
const RELOAD_KEY = "__chunk_reload_attempted__";
const isChunkLoadError = (msg: string) =>
  /Loading chunk [\d]+ failed/i.test(msg) ||
  /error loading dynamically imported module/i.test(msg) ||
  /Failed to fetch dynamically imported module/i.test(msg) ||
  /Importing a module script failed/i.test(msg);

const tryReload = (msg: string) => {
  if (!isChunkLoadError(msg)) return;
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, "1");
  } catch {
    // sessionStorage unavailable — still attempt a one-shot reload
  }
  window.location.reload();
};

window.addEventListener("error", (e) => {
  tryReload(e?.message || String(e?.error ?? ""));
});
window.addEventListener("unhandledrejection", (e) => {
  const reason: any = e?.reason;
  tryReload(typeof reason === "string" ? reason : reason?.message || "");
});

createRoot(document.getElementById("root")!).render(<App />);
